export const findNestedObj = (entireObj: unknown, keyToFind: string, valToFind: unknown): Record<string, unknown> | undefined => {
  let foundObj: Record<string, unknown> | undefined;
  JSON.stringify(entireObj, (_, nestedValue) => {
    if (nestedValue && nestedValue[keyToFind] === valToFind) {
      foundObj = nestedValue;
    }
    return nestedValue;
  });
  return foundObj;
};
